require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-generator-reasonable-node.json") })
        }
      }, "path---package-generator-reasonable-node");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-generator-reasonable-node!./.cache/json/package-generator-reasonable-node.json
// module id = 860
// module chunks = 231608221292675